// import { addLocaleData } from 'react-intl'

import russiaFlag from 'assets/img/flags/russia.svg'
import englandFlag from 'assets/img/flags/england.svg'
import latviaFlag from 'assets/img/flags/latvia.svg'
// import bulgraiaFlag from 'assets/img/flags/bulgraia.svg'
// import franceFlag from 'assets/img/flags/france.svg'
// import germanyFlag from 'assets/img/flags/germany.svg'
// import hungaryFlag from 'assets/img/flags/hungary.svg'
// import italyFlag from 'assets/img/flags/italy.svg'
// import kazahstanFlag from 'assets/img/flags/kazahstan.svg'
// import spainFlag from 'assets/img/flags/spain.svg'
// import turkeyFlag from 'assets/img/flags/turkey.svg'

import english from 'locales/en-US'
import russian from 'locales/ru-RU'
import latvian from 'locales/lv-LV'

export const FALLBACK_LOCALE = 'ru';

export const locales = {
  ru: {
    name: 'locales.russian',
    flag: russiaFlag,
    locales: russian
  },
  en: {
    name: 'locales.english',
    flag: englandFlag,
    locales: english
  },
  lv: {
    name: 'locales.latvian',
    flag: latviaFlag,
    locales: latvian
  },
  // bg: {
  //   name: 'locales.bulgarian',
  //   flag: bulgraiaFlag,
  //   locales: english
  // },
  // fr: {
  //   name: 'locales.french',
  //   flag: franceFlag,
  //   locales: english
  // },
  // de: {
  //   name: 'locales.deutsch',
  //   flag: germanyFlag,
  //   locales: english
  // },
  // hu: {
  //   name: 'locales.hungarian',
  //   flag: hungaryFlag,
  //   locales: english
  // },
  // it: {
  //   name: 'locales.italian',
  //   flag: italyFlag,
  //   locales: english
  // },
  // kk: {
  //   name: 'locales.kazakh',
  //   flag: kazahstanFlag,
  //   locales: english
  // },
  // es: {
  //   name: 'locales.spanish',
  //   flag: spainFlag,
  //   locales: english
  // },
  // tr: {
  //   name: 'locales.turkish',
  //   flag: turkeyFlag,
  //   locales: english
  // }
}

export const getBrowserLocale = () => {
  const locale = window.navigator && window.navigator.language.split('-')[0];

  if (isLocaleListed(locale)) {
    return locale;
  }

  return FALLBACK_LOCALE;
}

export const isLocaleListed = (locale) => locales[locale] !== undefined;

export const getLocaleData = (locale) => locale && locales[locale] || locales[FALLBACK_LOCALE];
